export default __webpack_public_path__ + "static/166-82c1eda7db31a48d35c5d4cb487cac5b.jpg";